export const NoticeController = {
    index(): void {},
};
